// Custom components
import FieldNameRenderer from 'components/TemplatePreview/Fields/FieldNameRenderer';
import RecordVideo from 'components/RecordVideo';
import { useState } from 'react';
import Unanswered from 'components/TemplatePreview/Fields/Unanswered';

const TakeVideo = ({
  item,
  answers = null,
  onChangeCb,
  templateLog,
  hideCorrectiveTask,
  onCorrectiveTaskCreationCb,
  isPreview,
  isPublic,
  log,
  workspaceId,
}: any) => {
  const [value, setValue] = useState(answers?.value ?? []);

  const handleChange = (filesUrls, otherProps = {}) => {
    if (onChangeCb) {
      const updatedValues = [...(filesUrls ?? [])];
      setValue(updatedValues);
      onChangeCb && onChangeCb(updatedValues, otherProps);
    }
  };

  return (
    <FieldNameRenderer
      templateLog={templateLog}
      fieldName={item.description}
      item={item}
      hideCorrectiveTask={hideCorrectiveTask}
      onCorrectiveTaskCreationCb={onCorrectiveTaskCreationCb}
      template={templateLog?.Checklist}
    >
      <RecordVideo
        attachments={value ?? []}
        onChangeCb={handleChange}
        isPreview={isPreview}
        isPublic={isPublic}
        log={log}
        workspaceId={workspaceId}
      />
      {isPreview && (!answers?.value || answers?.value?.length === 0) && (
        <Unanswered />
      )}
    </FieldNameRenderer>
  );
};

export default TakeVideo;
